export function Customization() {
  const customizations = [
    {
      title: 'Match Branding',
      description:
        'Apply your own colors, fonts, and brand assets to seamlessly integrate with your site.',
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1L13.5 2.5L14.5 3.5L9 9C7.9 9 7 9.9 7 11V14H9V22H13V18H15V22H19V14H21V11C21 9.9 20.1 9 19 9H21ZM7.5 7.5C8.3 7.5 9 6.8 9 6S8.3 4.5 7.5 4.5S6 5.2 6 6S6.7 7.5 7.5 7.5ZM18.5 7.5C19.3 7.5 20 6.8 20 6S19.3 4.5 18.5 4.5S17 5.2 17 6S17.7 7.5 18.5 7.5Z"
            fill="rgba(255, 255, 255, 0.9)"
          />
        </svg>
      ),
    },
    {
      title: 'Customize Goal',
      description:
        "Set specific objectives like engagement, growth, or monetization to optimize the AI's responses.",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22S22 17.52 22 12S17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12S7.59 4 12 4S20 7.59 20 12S16.41 20 12 20ZM12 6C8.69 6 6 8.69 6 12S8.69 18 12 18S18 15.31 18 12S15.31 6 12 6ZM12 16C9.79 16 8 14.21 8 12S9.79 8 12 8S16 9.79 16 12S14.21 16 12 16ZM12 10C10.9 10 10 10.9 10 12S10.9 14 12 14S14 13.1 14 12S13.1 10 12 10Z"
            fill="rgba(255, 255, 255, 0.9)"
          />
        </svg>
      ),
    },
    {
      title: 'Advanced Settings',
      description: 'Configure personality, speech, and search scope of the AI.',
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.14,12.94C19.18,12.64 19.2,12.33 19.2,12C19.2,11.68 19.18,11.36 19.14,11.06L21.25,9.37C21.46,9.22 21.54,8.95 21.43,8.73L19.43,5.27C19.32,5.05 19.05,4.97 18.83,5.05L16.38,6.05C15.88,5.65 15.35,5.32 14.76,5.07L14.4,2.42C14.36,2.18 14.16,2 13.92,2H9.92C9.68,2 9.48,2.18 9.44,2.42L9.08,5.07C8.5,5.32 7.96,5.66 7.47,6.05L5.02,5.05C4.8,4.96 4.53,5.05 4.42,5.27L2.42,8.73C2.31,8.95 2.4,9.22 2.6,9.37L4.71,11.06C4.67,11.36 4.65,11.68 4.65,12C4.65,12.32 4.67,12.64 4.71,12.94L2.6,14.63C2.4,14.78 2.31,15.05 2.42,15.27L4.42,18.73C4.53,18.95 4.8,19.03 5.02,18.95L7.47,17.95C7.96,18.34 8.5,18.68 9.08,18.93L9.44,21.58C9.48,21.82 9.68,22 9.92,22H13.92C14.16,22 14.36,21.82 14.4,21.58L14.76,18.93C15.35,18.68 15.88,18.34 16.38,17.95L18.83,18.95C19.05,19.03 19.32,18.95 19.43,18.73L21.43,15.27C21.54,15.05 21.46,14.78 21.25,14.63L19.14,12.94ZM12,15.6C10.02,15.6 8.4,13.98 8.4,12C8.4,10.02 10.02,8.4 12,8.4C13.98,8.4 15.6,10.02 15.6,12C15.6,13.98 13.98,15.6 12,15.6Z"
            fill="rgba(255, 255, 255, 0.9)"
          />
        </svg>
      ),
    },
  ]

  return (
    <section className="customization-section">
      <div className="customization-container">
        <h2 className="customization-title">Make it yours.</h2>
        <div className="customization-content">
          <div className="customization-image">
            <div className="branding-illustration">
              <div className="design-workspace">
                <div className="color-palette">
                  <div className="color-swatch"></div>
                  <div className="color-swatch"></div>
                  <div className="color-swatch"></div>
                </div>
                <div className="brand-elements">
                  <div className="logo-placeholder"></div>
                  <div className="typography-sample"></div>
                </div>
                <div className="customization-panel">
                  <div className="control-item"></div>
                  <div className="control-item"></div>
                  <div className="control-item"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="customization-list">
            {customizations.map((customization, index) => (
              <div key={index} className={`customization-item customization-item-${index + 1}`}>
                <div className="customization-icon">{customization.icon}</div>
                <div className="customization-text">
                  <h3 className="customization-feature-title">{customization.title}</h3>
                  <p className="customization-description">{customization.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
